
import { Link } from "react-router-dom";
import appStore from "../../assets/images/all-img/app-store.png";
import playStore from "../../assets/images/all-img/play-store.png";

export default function CtaHomeOne() {
	return (
		<div className="fugu-cta-section">
			<div className="container">
				<div className="row">
					<div className="col-lg-6">
						<div className="fugu-default-content large-content">
							<h2>Download now to invest crypto safely</h2>
						</div>
					</div>
					<div className="col-lg-6 d-flex align-items-center">
						<div className="fugu-cta-app-btn-wrap">
							<Link to={"contact"}  className="fugu-app-btn wow fadeInUpX" data-wow-delay="0s">
									<img src={appStore} alt="" />
								
							</Link>
							<Link to={"contact"} className="fugu-app-btn wow fadeInUpX" data-wow-delay=".20s">
									<img src={playStore} alt="" />
							
							</Link>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
